import { getCampaigns } from "data/campaigns";

export const getDonationId = (state) => state.voting_form.voting.get("donationId");

export const getAutoVote = (state) => state.voting_form.voting.get("autoVote");

export const getValidating = (state) => state.voting_form.voting.get("validating");

export const getError = (state) => state.voting_form.voting.get("error");

export const getVotingUserId = (state) => state.voting_form.voting.get("userId");

export const getSelectedCampaigns = (state) =>
  state.voting_form.voting.get("selectedCampaigns");

export const getAvailableVotes = (state) =>
  state.voting_form.voting.get("availableVotes");

export const getTotalVotes = (state) => state.voting_form.voting.get("totalVotes");

export const getCampaignThatLaunchedForm = (state) =>
  state.voting_form.voting.get("campaignIdThatLaunchedForm");

export const getLoading = (state) => state.voting_form.voting.get("loading");

export const getPaginationLoading = (state) =>
  state.voting_form.voting.get("paginationLoading");

export const getQuery = (state) => state.voting_form.voting.get("query");

export const getSelectedCategory = (state) =>
  state.voting_form.voting.get("selectedCategory");

export const getSubmitError = (state) => state.voting_form.voting.get("submitError");

export const getFilteredCampaigns = (state) => {
  const query = getQuery(state);
  const category = getSelectedCategory(state);

  return getCampaigns(state)
    .filter((campaign) => {
      if (category) {
        return (
          campaign.get("category") &&
          campaign.get("category").toLowerCase() === category.toLowerCase()
        );
      } else {
        return campaign;
      }
    })
    .filter(
      (campaign) =>
        campaign.get("name") &&
        campaign.get("name").toLowerCase().includes(query.toLowerCase()),
    );
};

export const getVotingModalState = (state) => state.voting_form.voting.get("isModalOpen");
